export const slideWidthPx = 54;
export const slidesPerView = 13;
